import { get } from 'lodash';
import { HTTP_METHODS } from '../../constants/http';
import { ERROR_STATUS } from '../../constants/error';

const UNDEFINED_RESPONSE = 'Undefined/null response';
const UNDEFINED_URL = 'Undefined URL';
const EMPTY_STATUS = 'Empty status';
const EMPTY_STATUS_TEXT = 'Empty status text';

export const isAudioSavingRequest = ({ endpoint = '', requestConfig: { method } = {} } = {}) =>
    endpoint.includes('student_voice_recording') && method === HTTP_METHODS.POST;

export const isAddBookResultRequest = ({ requestConfig = {} } = {}) =>
    requestConfig.method === HTTP_METHODS.PATCH &&
    JSON.parse(get(requestConfig, 'body', '{}')).operation === 'add_book_result';

export const constructResponseError = response => {
    let errorMessage;
    let statusCode;
    if (response === undefined || response === null) {
        errorMessage = UNDEFINED_RESPONSE;
        statusCode = UNDEFINED_RESPONSE;
    } else {
        const url = response.url || UNDEFINED_URL;
        const statusText = response.statusText || EMPTY_STATUS_TEXT;
        statusCode = response.status || EMPTY_STATUS;
        errorMessage = `Error code: ${statusCode}; text: ${statusText}; url: ${url}`;
    }

    const error = Object.assign(new Error(errorMessage), {
        status: ERROR_STATUS.HTTP_ERROR,
        statusCode,
    });
    return error;
};
